import React from "react";

import styles from "./TrackingLinks.module.scss";

const hasTrackingDetail = ({ carrier, number, url } = {}) =>
  Boolean(carrier || number || url);

const isSafeTrackingUrl = (url) => {
  if (!url) {
    return false;
  }

  try {
    return ["http:", "https:"].includes(new URL(url).protocol);
  } catch {
    return false;
  }
};

const TrackingLinks = ({ tracking, className = "" }) => {
  if (!Array.isArray(tracking)) {
    return null;
  }

  const dispatches = tracking.filter(hasTrackingDetail);

  if (!dispatches.length) {
    return null;
  }

  return (
    <div className={`${styles.trackingLinks} ${className}`}>
      {dispatches.map((dispatch, index) => {
        const { carrier, number, url } = dispatch;
        const safeUrl = isSafeTrackingUrl(url);
        const trackingLabel =
          number ||
          (dispatches.length > 1
            ? `Track parcel ${index + 1}`
            : "Track parcel");
        const accessibleLabel = [
          `Track parcel${dispatches.length > 1 ? ` ${index + 1}` : ""}`,
          carrier ? `with ${carrier}` : null,
          number ? `tracking number ${number}` : null,
        ]
          .filter(Boolean)
          .join(", ");

        return (
          <div className={styles.dispatch} key={`${number || url || "dispatch"}-${index}`}>
            {carrier && (
              <p className="gkit-p-15 fw-bold mb-0">{carrier}</p>
            )}
            {safeUrl ? (
              <a
                aria-label={accessibleLabel}
                className={`${styles.trackingLink} gkit-p-15`}
                href={url}
                rel="noopener noreferrer"
                target="_blank"
              >
                {trackingLabel}
              </a>
            ) : (
              number && <p className="gkit-p-15 mb-0">{number}</p>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default TrackingLinks;
export { hasTrackingDetail, isSafeTrackingUrl };
